import { z } from "zod";

import { currentWorkDate } from "@/lib/format.ts";

export const measurementSchema = z.object({
	measuredOn: z
		.string()
		.min(1, "Informe a data da medição.")
		.refine((value) => value <= currentWorkDate(), {
			message: "A data da medição não pode ser futura.",
		}),
	progressPercent: z
		.string()
		.min(1, "Informe o percentual executado.")
		.refine((value) => /^\d+$/.test(value.trim()), {
			message: "Informe um número inteiro entre 0 e 100.",
		})
		.refine((value) => Number(value) >= 0 && Number(value) <= 100, {
			message: "O percentual deve estar entre 0 e 100.",
		}),
	note: z.string().max(500, "A nota deve ter no máximo 500 caracteres."),
});

export type MeasurementFormValues = z.infer<typeof measurementSchema>;
